<template>
  <div class="app-container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        :label="item.title"
        :name="item.name"
        v-for="(item, index) in menuList"
        :key="index"
      ></el-tab-pane>
    </el-tabs>
    <div class="head">
      <el-select
        filterable
        v-model="screen.park_id"
        placeholder="请选择园区"
        v-if="userInfo.park_id == 0"
        multiple
        collapse-tags
        class="mr1"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="screen.start_time"
        type="date"
        placeholder="开始时间"
        value-format="timestamp"
        class="mr1"
      >
      </el-date-picker>
      <el-date-picker
        v-model="screen.end_time"
        type="date"
        placeholder="结束时间"
        value-format="timestamp"
        class="mr1"
      >
      </el-date-picker>
      <div class="btn">
        <el-button type="primary" @click="(page = 1), fetchData()"
          >筛选</el-button
        >
        <el-button type="primary" plain @click="cZhi()">重置</el-button>
      </div>
    </div>
    <div style="margin-top: 20px">
      <el-button
        size="medium"
        type="warning"
        @click="derive()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/equipment/export')"
        >导出</el-button
      >
    </div>

    <!-- <div class="table">
      <el-row class="headBg">
        <el-col :span="spanNum" v-for="(item, index) in tableHead" :key="index">
          <div class="grid-content">{{ item }}</div>
        </el-col>
      </el-row>
      <div class="tableData">
        <el-row v-for="(item, index) in tableData" :key="index">
          <el-col :span="spanNum" v-for="(item1, index1) in item" :key="index1">
            <div class="grid-content">{{ item1 }}</div>
          </el-col>
        </el-row>
      </div>
    </div> -->
    <!-- <el-button type="danger" @click="next()">下一页</el-button> -->
    <!-- v-el-table-infinite-scroll="load"
                :default-sort="{prop: 'last_report_time', order: 'descending'}" -->
    <el-table
      max-height="1000"
      :default-sort="{ prop: 'last_report_time', order: 'descending' }"
      v-el-table-infinite-scroll="scrollLoad"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      v-loading="loading"
      class="table"
      stripe
      :data="tableData"
      ref="table"
      style="width: 100%"
      :infinite-scroll-immediate="false"
      infinite-scroll-distance="'0px'"
    >
      <el-table-column
        :prop="item.prop"
        :label="item.label"
        v-for="(item, index) in tableHead"
        :key="index"
      >
      </el-table-column>
    </el-table>
    <!-- <el-alert v-if="isFlag"
                title="正在努力加载中..."
                type="success"
                center
                :closable="false"
                show-icon>
    </el-alert> -->
    <el-alert
      v-if="isMore"
      title="没有更多啦！"
      type="warning"
      center
      show-icon
    >
    </el-alert>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { openPark } from "@/api/index";
import {
  patrol,
  maintenance,
  maintenance_type,
  maintenance_response_rate,
  maintenance_type_response_rate,
  maintenance_finish_analysis,
  patrol_personal,
  statisticsExport,
  facility,
  facility_elevator,
} from "@/api/statistics";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl"]),
  },
  name: "statistics",
  data() {
    return {
      activeName: "patrol",
      menuList: [
        {
          title: "品质巡检任务统计",
          power: "/statistics/patrol",
          name: "patrol",
        },
        {
          title: "报事统计列表",
          power: "/statistics/maintenance",
          name: "maintenance",
        },
        {
          title: "报事类型统计",
          power: "/statistics/maintenance_type",
          name: "maintenance_type",
        },
        {
          title: "报事响应率统计",
          power: "/statistics/maintenance_response_rate",
          name: "maintenance_response_rate",
        },
        {
          title: "报事类型响应率统计",
          power: "/statistics/maintenance_type_response_rate",
          name: "maintenance_type_response_rate",
        },
        {
          title: "及时完成率分析",
          power: "/statistics/maintenance_finish_analysis",
          name: "maintenance_finish_analysis",
        },
        // {
        //   title: "个人巡检统计",
        //   power: "/statistics/patrol_personal",
        //   name: "patrol_personal",
        // },
        // {
        //   title: "设备巡检任务统计",
        //   power: "/statistics/facility",
        //   name: "facility",
        // },
        // {
        //   title: "电梯巡检任务统计",
        //   power: "/statistics/facility_elevator",
        //   name: "facility_elevator",
        // }
      ],
      screen: {
        park_id: [],
        start_time: "",
        end_time: "",
      },
      page: 1,
      page_size: 15,
      parkList: [],
      tableHead: [],
      tableData: [],
      spanNum: "",
      loading: true,
      isFlag: false,
      isMore: false,
      alertShow: false,
    };
  },
  watch: {},
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.getPark();
    this.getPatrol();
  },
  mounted() {},
  methods: {
    // 导出
    derive() {
      let data = {
        park_id: this.screen.park_id.toString(),
        filter_start_time: this.screen.start_time
          ? this.screen.start_time / 1000
          : "",
        filter_end_time: this.screen.end_time
          ? this.screen.end_time / 1000
          : "",
      };
      const loading = this.$loading({
        lock: true,
        text: "数据量过大，正在导出中...",
        spinner: "el-icon-loading",
      });
      statisticsExport(data)
        .then((res) => {
          loading.close();
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
          });
          // let fileName = decodeURI(res.headers.content-disposition).replace(/attachment;filename=/, '')
          let downloadElement = document.createElement("a");
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = res.name;
          // downloadElement.target="_blank"
          downloadElement.setAttribute("target", "_blank");
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((error) => {
          loading.close();
        });
    },
    next() {
      this.page++;
      this.getPatrolPersonal();
    },
    scrollLoad() {
      if (this.alertShow) {
        this.isMore = false;
        // this.isFlag = true;
        this.page++;
        if (this.activeName == "patrol_personal") {
          // this.getPatrolPersonal();c
        }
      }
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    handleClick(tab, event) {
      this.activeName = tab.name;
      if (tab.type != "screen") {
        // this.screen = {
        //   park_id: [],
        //   start_time: "",
        //   end_time: "",
        // };
        if (this.userInfo.park_id != 0) {
          this.screen.park_id.push(this.userInfo.park_id);
        }
      }
      var that = this;
      this.page = 1;
      this.loading = true;
      this.isMore = false;
      if (tab.name == "patrol") {
        that.getPatrol();
      } else if (tab.name == "maintenance") {
        that.getMaintenance();
      } else if (tab.name == "maintenance_type") {
        that.getMaintenanceType();
      } else if (tab.name == "maintenance_response_rate") {
        that.getMaintenanceRR();
      } else if (tab.name == "maintenance_type_response_rate") {
        that.getMaintenanceTRR();
      } else if (tab.name == "maintenance_finish_analysis") {
        that.getMaintenanceFA();
      } else if (tab.name == "patrol_personal") {
        that.getPatrolPersonal();
      } else if (tab.name == "facility") {
        that.getMaintenanceFacility();
      } else if (tab.name == "facility_elevator") {
        that.getMaintenanceFE();
      }
    },
    // 筛选
    fetchData() {
      this.handleClick({ name: this.activeName, type: "screen" });
    },
    // 重置
    cZhi() {
      this.screen = {
        park_id: [],
        start_time: "",
        end_time: "",
      };
      this.handleClick({ name: this.activeName });
    },
    // 获取品质巡检任务统计
    getPatrol() {
      let data = {
        park_id: this.screen.park_id.toString(),
        filter_start_time: this.screen.start_time
          ? this.screen.start_time / 1000
          : "",
        filter_end_time: this.screen.end_time
          ? this.screen.end_time / 1000
          : "",
      };
      var that = this;
      patrol(data).then((res) => {
        that.formatting(res.data.head, res.data.data);
      });
    },
    // 获取各个园区报事统计
    getMaintenance() {
      let data = {
        park_id: this.screen.park_id.toString(),
        filter_start_time: this.screen.start_time
          ? this.screen.start_time / 1000
          : "",
        filter_end_time: this.screen.end_time
          ? this.screen.end_time / 1000
          : "",
      };
      var that = this;
      maintenance(data).then((res) => {
        // this.tableHead = res.data.head;
        // this.tableData = res.data.data;
        // that.renewal();
        that.formatting(res.data.head, res.data.data);
      });
    },
    // 获取各个园区报事类型统计
    getMaintenanceType() {
      let data = {
        park_id: this.screen.park_id.toString(),
        filter_start_time: this.screen.start_time
          ? this.screen.start_time / 1000
          : "",
        filter_end_time: this.screen.end_time
          ? this.screen.end_time / 1000
          : "",
      };
      var that = this;
      maintenance_type(data).then((res) => {
        // this.tableHead = res.data.head;
        // this.tableData = res.data.data;
        // that.renewal();
        that.formatting(res.data.head, res.data.data);
      });
    },
    // 获取各个园区报事响应率统计
    getMaintenanceRR() {
      let data = {
        park_id: this.screen.park_id.toString(),
        filter_start_time: this.screen.start_time
          ? this.screen.start_time / 1000
          : "",
        filter_end_time: this.screen.end_time
          ? this.screen.end_time / 1000
          : "",
      };
      var that = this;
      maintenance_response_rate(data).then((res) => {
        // this.tableHead = res.data.head;
        // this.tableData = res.data.data;
        // that.renewal();
        that.formatting(res.data.head, res.data.data);
      });
    },
    // 获取报事类型响应率统计
    getMaintenanceTRR() {
      let data = {
        park_id: this.screen.park_id.toString(),
        filter_start_time: this.screen.start_time
          ? this.screen.start_time / 1000
          : "",
        filter_end_time: this.screen.end_time
          ? this.screen.end_time / 1000
          : "",
      };
      var that = this;
      maintenance_type_response_rate(data).then((res) => {
        // this.tableHead = res.data.head;
        // this.tableData = res.data.data;
        // that.renewal();
        that.formatting(res.data.head, res.data.data);
      });
    },
    // 获取及时完成率分析
    getMaintenanceFA() {
      let data = {
        park_id: this.screen.park_id.toString(),
        filter_start_time: this.screen.start_time
          ? this.screen.start_time / 1000
          : "",
        filter_end_time: this.screen.end_time
          ? this.screen.end_time / 1000
          : "",
      };
      var that = this;
      maintenance_finish_analysis(data).then((res) => {
        // this.tableHead = res.data.head;
        // this.tableData = res.data.data;
        // that.renewal();
        that.formatting(res.data.head, res.data.data);
      });
    },
    // 获取个人巡检统计
    getPatrolPersonal() {
      let data = {
        park_id: this.screen.park_id.toString(),
        filter_start_time: this.screen.start_time
          ? this.screen.start_time / 1000
          : "",
        filter_end_time: this.screen.end_time
          ? this.screen.end_time / 1000
          : "",
        // page: this.page,
        // page_size: this.page_size,
      };
      var that = this;
      patrol_personal(data).then((res) => {
        if (res.data.data.length == 0) {
          this.alertShow = false;
          this.isMore = true;
          // this.isFlag = false;
        } else {
          this.alertShow = true;
        }
        // this.tableHead = res.data.head;
        // this.tableData = res.data.data;
        // that.renewal();
        that.formatting(res.data.head, res.data.data);
      });
    },
    // 获取设备巡检任务统计
    getMaintenanceFacility() {
      let data = {
        park_id: this.screen.park_id.toString(),
        filter_start_time: this.screen.start_time
          ? this.screen.start_time / 1000
          : "",
        filter_end_time: this.screen.end_time
          ? this.screen.end_time / 1000
          : "",
        // page: this.page,
        // page_size: this.page_size,
      };
      var that = this;
      facility(data).then((res) => {
        if (res.data.data.length == 0) {
          this.alertShow = false;
          this.isMore = true;
          // this.isFlag = false;
        } else {
          this.alertShow = true;
        }
        // this.tableHead = res.data.head;
        // this.tableData = res.data.data;
        // that.renewal();
        that.formatting(res.data.head, res.data.data);
      });
    },
    // 获取电梯巡检任务统计
    getMaintenanceFE() {
      let data = {
        park_id: this.screen.park_id.toString(),
        filter_start_time: this.screen.start_time
          ? this.screen.start_time / 1000
          : "",
        filter_end_time: this.screen.end_time
          ? this.screen.end_time / 1000
          : "",
        // page: this.page,
        // page_size: this.page_size,
      };
      var that = this;
      facility_elevator(data).then((res) => {
        if (res.data.data.length == 0) {
          this.alertShow = false;
          this.isMore = true;
          // this.isFlag = false;
        } else {
          this.alertShow = true;
        }
        // this.tableHead = res.data.head;
        // this.tableData = res.data.data;
        // that.renewal();
        that.formatting(res.data.head, res.data.data);
      });
    },

    // 表格属性格式化
    formatting(headData, tabularData) {
      this.tableHead = [];

      if (this.page == 1) {
        this.tableData = [];
      }
      headData.forEach((item, index) => {
        this.tableHead.push({
          label: item,
          prop: "prop" + index,
        });
      });
      tabularData.forEach((item, index) => {
        let data = {};
        item.forEach((item, index) => {
          this.$set(data, "prop" + index, item);
        });
        this.tableData.push(data);
      });

      this.loading = false;
    },
    // 更新表格
    renewal() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mr1 {
  margin-right: 10px;
}
.head {
  display: flex;
  flex-wrap: wrap;
  .btn {
    display: inline-block;
  }
}
.table {
  margin-top: 30px;
}
.el-row {
  &:last-child {
    margin-bottom: 0;
  }
  border: 1px solid #e5e9f2;
}
.el-col {
  // border-radius: 4px;
  border-right: 1px solid #e5e9f2;
  text-align: center;
}
.headBg {
  .el-col {
    // border-radius: 4px;
    border-right: 1px solid #fff;
  }
}
.grid-content {
  // border-radius: 4px;
  min-height: 36px;
  line-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.headBg {
  background: #e5e9f2;
}
// .fa{
//   background: #fafafa;
// }
.tableData {
  .el-col {
    // border-radius: 4px;
    border-right: none;
  }
  .el-row:nth-child(even) {
    background: #fafafa;
    // background: red;
  }
}
::v-deep.el-table::before {
  display: none !important;
}
</style>
